import { Injectable } from '@angular/core';
import { LogEntry } from '@timechef/core/logging/log-entry';
import { Sink } from '@timechef/core/logging/sinks/sink';
import { AppRepository } from '@timechef/core/state';
import { Observable, of } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { LogLevel } from 'src/environments/environment-config';

@Injectable({ providedIn: 'root' })
export class InAppSink extends Sink {
  private buffer: LogEntry[] = [];
  private initialized = false;

  /**
   * Buffers logs until the application repository reports initialization,
   * then flushes buffered entries once.
   */
  constructor(private appRepo: AppRepository) {
    super({ isActive: true, logLevel: LogLevel.Debug });

    this.appRepo.instance.initialized$
      .pipe(
        filter((initialized) => initialized),
        take(1),
      )
      .subscribe(() => {
        this.initialized = true;
        this.flushBuffer();
      });
  }

  /**
   * Logs an entry to the app repository, or buffers it until initialization.
   */
  log(entry: LogEntry): Observable<void> {
    if (!this.initialized) {
      this.buffer.push(entry);
      return of();
    }

    this.appRepo.pushLog(entry);
    return of();
  }

  /**
   * Flushes any buffered log entries to the app repository.
   */
  private flushBuffer(): void {
    for (const entry of this.buffer) {
      this.appRepo.pushLog(entry);
    }
    this.buffer = [];
  }
}
